import { GetFormFieldComponent } from './../../DynamicFormsModule/formsFields/components/get/get.component';
import { SharedModule } from './../../shared/shared.module';
import { ThemeModule } from './../../../@theme/theme.module';
import { DeletePhaseComponent } from './phase/components/delete/delete.component';
import { UpdateComponent } from './activity/components/update/update.component';
import { DetailsComponent } from './activity/components/details/details.component';
import { DeleteComponent } from './activity/components/delete/delete.component';
import { CreateRequestComponent } from './requests/components/create-request/create-request.component';

import { CreatePhaseComponent } from './phase/components/create/create.component';
import { GetComponent } from './work-flow/components/get/get.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbCardModule,
  NbButtonModule,
  NbMenuModule,
  NbLayoutModule,
  NbTabsetModule,
  NbSelectModule,
  NbDialogModule,
  NbListModule,
  NbWindowModule,
  NbRadioModule,
  NbToggleModule,
  NbIconModule,
  NbAccordionModule,
  NbStepperModule,
} from '@nebular/theme';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ngx-custom-validators';

import { GetActivityComponent } from './activity/components/get/get.component';
import { WorkFlowRoutingModule } from './work-flow-routing.module';
import { CreateWorkFlowComponent } from './work-flow/components/create/create.component';
import { CreateActivityComponent } from './activity/components/create/create.component';
import { WorkflowDetailsComponent } from './work-flow/components/workflow-details/workflow-details.component';
import { GetRequestsComponent } from './requests/components/get-requests/get-requests.component';
import { MyRequestsComponent } from './requests/components/my-requests/my-requests.component';
import { MyRequestsDetailsComponent } from './requests/components/my-requests-details/my-requests-details.component';
import { WorkFlowComponent } from './work-flowComponent';

import { FollowRequestComponent } from './requests/components/follow-request/follow-request.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AllRequestsComponent } from './requests/components/all-requests/all-requests.component';
import { FollowRequestsComponent } from './requests/components/follow-requests/follow-requests.component';
import { DynamicFormsModule } from '../../DynamicFormsModule/dynamicForms.module';

import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { EditPhaseComponent } from './phase/components/edit/edit.component';
import { GetFormMasterFieldsPopupComponent } from '../../DynamicFormsModule/formsMaster/components/get.fields.popup/get.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './translation/', '.json');
}

@NgModule({
  imports: [
    WorkFlowRoutingModule,
    NbMenuModule,
    NbCardModule,
    NbButtonModule,
    SharedModule,
    FormsModule,
    CustomFormsModule,
    NbLayoutModule,
    NbTabsetModule,
    NbSelectModule,
    ReactiveFormsModule,
    NbListModule,
    NbDialogModule.forChild(),
    TranslateModule,
    NbRadioModule,
    NbToggleModule,
    NbWindowModule.forChild(),
    ThemeModule,
    DynamicFormsModule,
    NbIconModule,
    NbAccordionModule,
    NbStepperModule,
    CommonModule,
  ],
  declarations: [
    GetActivityComponent,
    GetComponent,
    CreateWorkFlowComponent,
    CreatePhaseComponent,
    CreateActivityComponent,
    WorkflowDetailsComponent,
    GetRequestsComponent,
    MyRequestsComponent,
    MyRequestsDetailsComponent,
    WorkFlowComponent,
    CreateActivityComponent,
    FollowRequestComponent,
    CreateRequestComponent,
    DeleteComponent,
    DetailsComponent,
    UpdateComponent,
    DeletePhaseComponent,
    AllRequestsComponent,
    FollowRequestsComponent,
    EditPhaseComponent,
  ],
  exports: [GetComponent],
  entryComponents: [
    WorkflowDetailsComponent,
    FollowRequestsComponent,
    MyRequestsDetailsComponent,
    FollowRequestComponent,
    GetFormMasterFieldsPopupComponent,
    CreatePhaseComponent,
    EditPhaseComponent,
    CreateWorkFlowComponent
  ],
})
export class WorkFlowModule { }
